import React, { useContext, useEffect } from 'react';
import { ReportSkusModalContext } from './ReportSkusModal';
import SongsTable from './SongsTable';

const Confirm = ({ songs, count, missing }) => {
  const { setStep } = useContext(ReportSkusModalContext);

  return (
    <div className="row fade in">
      <div className='col-md-12'>
        <SongsTable songs={songs} count={count} missing={missing} />

        <div className='row'>
          <div className="col-sm-5 pr-0">
            <button onClick={() => setStep(1)} type="button" className="btn btn-block btn-purple">
              Back
            </button>
          </div>

          <div className="col-sm-7">
            <button
              type="button"
              className="btn btn-block btn-purple"
              onClick={() => setStep(3)}
              disabled={!count}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirm;